export const MAX_SIZE_MB = 100;
export const LAST_ASK_HOURS_DURATION = 24;
